import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    this.show()
    // Auto-dismiss after 5 seconds (adjust as needed)
    setTimeout(() => this.dismiss(), 4000)
  }

  show() {
    this.messageTarget.classList.add('show')
  }

  dismiss() {
    this.messageTarget.classList.add('hide')
    this.messageTarget.addEventListener('transitionend', () => {
      this.messageTarget.remove()
    }, { once: true })
  }
}